module.exports = __webpack_public_path__ + "img/能源统计分析.384e97cb.png";